import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../../context/SubscriptionContext';

/**
 * Renders its children only when the user's trial hasn't expired.
 * When `trial_expired=true`, redirects to /app/trial-end so the user
 * must pick a paid plan before continuing to use the app.
 *
 * Excluded paths:
 *   - /app/trial-end, /app/upgrade, /app/einstellungen (so they can pay/update)
 *   - /app/admin  (admins always pass)
 */
export const TrialGuard = ({ children }) => {
  const sub = useSubscription();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (sub.loading) return;
    if (!sub.trial_expired) return;

    const p = location.pathname;
    const exempt = [
      '/app/trial-end',
      '/app/upgrade',
      '/app/einstellungen',
      '/app/admin',
    ];
    if (exempt.some(x => p.startsWith(x))) return;

    navigate('/app/trial-end', { replace: true });
  }, [sub.loading, sub.trial_expired, location.pathname, navigate]);

  return children;
};

export default TrialGuard;
